import React, { Component } from 'react'
import PlusIcon from '../../icons/plusicon';
import SearchIcon from '../../icons/searchicon';
import FilterActiveIcon from '../../icons/filteractiveicon';
import FilterIcon from '../../icons/filtericon';
import { Link } from 'react-router-dom';
import ReactPaginate from "react-paginate";
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import service from '../../services';
import { ActCreators } from '../../redux/bindActionCretor';
import Loader from '../../component/loader';
import UploadImg from '../../assets/images/cloud-data-upload-icon.svg'
import UploadImgicon from '../../assets/images/upload_csv_icon.png'

import commonImage from '../../commonImage';
import ErrorPopUp from '../../component/errorPopUp';
import CsvUploadLocationModal from './CsvUploadLocationModal';

let statusFilterList = []

const mapStateToProps = state => ({
    LocationEditId: state.locationEditId,
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};
let sub;
class LocationsList extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loaderFlag: false,
            offset: 0,
            perPage: 20,
            pageCount: 0,
            currentPage: 0,
            searchField: '',
            statusArray: [
                { assign: "Activate", list: 1, value: false },
                { assign: "Deactivate", list: 2, value: false },
            ],
            showModalPopup: false,
            uploadCSVModal: false,
            totalAddedRecord: 0,
            totalSkippedRecord: 0,
            skippedUser: [],
            locationListArray: [],
            venueType: [],
           fileUploading: false,
        }
        this.apiserve = new service();
    }

    isShowPopup = (status) => {
        this.setState({ showModalPopup: status });
      };
    
      onCancleFilter = () => {
        this.setState({
          showModalPopup: false
        })
      }

    componentWillUnmount = () => {
        sub.unsubscribe();
        statusFilterList = []
    };

    componentDidMount() {
        this.getLocationFilter(this.state.currentPage, this.state.perPage)
        // this.apiserve.sendevent("location|getList", {});
        this.apiserve.sendevent("user|sff|getAllInitialForRedis", {});

        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "user|sff|getAllInitialForRedis":
                    if (!response.error)
                        this.setState({
                            venueType: response ?.data ?.location ?.venueType,
                        })

                    break;
                case "location|getList":
                    if (!response.error)
                        this.setState({
                            locationListArray: response ?.data ?.docs,
                            pageCount: Math.ceil(response ?.data ?.totalDocs / this.state.perPage),
                            loaderFlag: false
                        })

                    break;
                    case "admin|location|importCsv":
                        if (!response.error) {
                            this.setState({
                                fileUploading: false,
                                totalAddedRecord: response.data.totalProcessedRecord,
                                totalSkippedRecord: response.data.totalSkippedRecord,
                                skippedUser: response.data.skipUserArray
                            }, () => {
                                this.setState({
                                    // successmodal: true,
                                    uploadCSVModal: true
                                })
                            })
                        this.apiserve.sendevent("location|getList", {});
                        }
                        else {
                            this.apiserve.error(response.data.error)
                        }
                        break;
                    break;
            }
        })

    }

    EditLocation = (id) => {
        this.props.LocationEditData(id)
        this.props.history.push(`/location/${this.props.LocationEditId}`);
    }

    onSearchFilter = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            currentPage: 0
        }, () => {
            var data = {
                page: 1,
                limit: 50,
            }
            if (this.state.searchField.length) {
                data.filter = this.state.searchField
            }
            this.apiserve.sendevent("location|getList", data)
        })
        let searchdata = this.state.locationListArray;
        searchdata = searchdata.filter((data) => {
            return data.name.toLocaleLowerCase().includes(e.target.value.toLocaleLowerCase())
        })
        this.setState({
            locationListArray: searchdata
        })
    }


    getLocationFilter = (skip, limit, isClearStatusType) => {
        let data = {}
        data.page = skip
        data.limit = limit
        if (statusFilterList && statusFilterList.length) {
            data.status = statusFilterList
        }
        this.apiserve.sendevent("location|getList", data)
    }

    StatusFilter = (e, selectedInex, isClearStatusType = false) => {
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let approvePassList = [...this.state.statusArray]

        approvePassList.forEach((item, i) => {
            if (i === index) {
                approvePassList[i].value = event
            }
            if (isClearStatusType) {
                approvePassList[i].value = false
                statusFilterList = []
            }
        })
        this.setState({
            ...this.state,
            statusArray: approvePassList,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    statusFilterList = [...statusFilterList, this.state.statusArray[index].list];
                }
            } else {
                if (index !== null) {
                    let tempArray = statusFilterList.filter((d) => d !== this.state.statusArray[index].list);
                    statusFilterList = tempArray;
                }
            }
            this.getLocationFilter(this.state.currentPage, this.state.perPage, isClearStatusType)
        })

    }

    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage + 1;
        this.setState(
            {
                currentPage: selectedPage,
                offset: offset,
            },
            () => {
                localStorage.setItem('currentPage', this.state.currentPage)
                localStorage.setItem('offset', offset)
                localStorage.setItem('perPage', this.state.perPage)
                this.getLocationFilter(offset, this.state.perPage)
            }
        );
    }


    AddLocation = () => {
        this.props.LocationEditData("")
        this.props.history.push('/create-location');
    }

    downloadcsv = () => {
        window.open(`https://d2wsrejhnxatgp.cloudfront.net/locationCSV/sample.csv`)
        this.setState({
            showModalPopup: false
        })
   }


   uploadCSV = (e) => {
     let file = e.target.files[0];
     if ((file.type === 'text/csv' || file.type === 'application/vnd.ms-excel') || file.name.includes('.csv')) {
         this.setState({
             fileUploading: true
         })
         let reader = new FileReader();
         reader.readAsDataURL(file);
         reader.onloadend = (event) => {
             setTimeout(() => {
                 this.imageUploadScreen(file,false,event.target.result);
             }, 0);
         };
         e.target.value = ''
     } else {
         this.setState({ errorMsg: 'please upload .csv file only', errorPopup: true, fileUploading: false })
     }
 }

 imageUploadScreen = (file,IsFPGUpload=true, img) => {
     var fileSet = commonImage(file,IsFPGUpload, this.apiserve.formbucketLocationCSV, img)
     fileSet.then((value) => {
         var data1 = {
             url: encodeURI(process.env.REACT_APP_IMAGE_URL + value)
         }
         this.apiserve.sendevent("admin|location|importCsv", data1);
     });
 };
 
 errorMsgPopup = () => {
   this.setState({
       errorPopup: false
   })
 }

 CloseModal = () => {
    this.setState({
        uploadCSVModal:false,
        showModalPopup: false
    })
  }

    render() {
        const { locationList, locationListArray } = this.state
        return (
            <div className="right_side_wrapper ">
                <ul className="fpg_admin_tab disp_flex">
                    <li className="active">
                        <p className="uppercase text_left">
                            <div>LOCATION LIST</div>
                            {/* <Link to="/create-location"><PlusIcon /></Link> */}
                            <span onClick={() => this.isShowPopup(true)} style={{right:'60px',background:'#6a6a6a'}}> <img src={UploadImgicon}  style={{position:'absolute',right:'16px',bottom:'16px',width:'22px',height:'auto'}}/></span>
                            <span onClick={this.AddLocation}><PlusIcon /></span>
                        </p>
                    </li>
                </ul>
                <div className="dashboard_header no_bg p_0 mt_10 mb_10">
                    <div className="searchBlock back_date pl_15">
                        <form onSubmit={e => { e.preventDefault(); }} className="m_0">
                            <input
                                className="bg_white"
                                type="text"
                                autoComplete="false"
                                placeholder="Search"
                                id="searchField"
                                name="searchField"
                                value={this.state.searchField}
                                onChange={this.onSearchFilter}
                            />
                            <button type='button' style={{ pointerEvents: 'none' }}>
                                {/* <img src={serachIcon} /> */}
                                <SearchIcon />
                            </button>
                        </form>
                    </div>
                </div>
                <div className="table_wrap dashboard_data film_list_table striped_table">
                    <table>
                        <thead>
                            <tr>
                                <th className="email_d" style={{ width: "240px" }}>  Name </th>
                                <th className="user_firstName_d" style={{ width: "170px" }}>Street Address</th>
                                <th className="user_lastName_d" style={{ width: "170px" }}>Venue Type</th>
                                <th className="user_company_d depart_d" style={{ width: "350px" }}>
                                    <span className="disp_flex d_flex_align_center">
                                        Status
                                    {statusFilterList && statusFilterList.length ?
                                            <FilterActiveIcon />
                                            :
                                            <FilterIcon />
                                        }
                                    </span>
                                    <div className="tabelData_popup" style={{ left: "0" }}>
                                        <form>
                                            <div className="customCheck">
                                                <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                                    <p className="link" onClick={() => this.StatusFilter(null, null, true)} > Clear All </p>
                                                </div>

                                                <div className="customCheckBox">
                                                    {this.state.statusArray.map((item, i) => (
                                                        <div className="customCheckBox">
                                                            <input
                                                                type="checkbox"
                                                                id={'status' + item.list}
                                                                name={'status' + item.list}
                                                                value={item.list ? true : false}
                                                                checked={item.value ? true : false}
                                                                onClick={(e) => this.StatusFilter(e, i)}
                                                            />
                                                            <label htmlFor={'status' + item.list}>{item.assign}</label>
                                                        </div>
                                                    ))
                                                    }
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                locationListArray && locationListArray.length > 0 && locationListArray.map((item) => {
                                    return (

                                        <tr className={`pointer ${item.status === 1 ? '' : 'disable'}`} onClick={() => this.EditLocation(item._id)}>
                                            <td className="email_d user_email_d" style={{ width: "240px" }}>
                                                <strong>{item.name}</strong>
                                            </td>
                                            <td className="firstName_d" style={{ width: "170px" }}><p>{item ?.street}</p></td>
                                            <td className="lastName_d" style={{ width: "170px" }}><p>{item ?.venueType ?.name}</p></td>
                                            <td className="depart_d" style={{ width: "350px" }}><p>{item.status === 1 ? "Active" : "Inactive"}</p></td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>

                  
                    {this.state.showModalPopup && (
                      <div className='user_popup active'>
                        <span className="popup_overlay" onClick={this.onCancleFilter}></span>
                        <div className="sundance_popup_detail box_shadow approve_success_popup bg_white overflow_initial fpg_csv_btn" >
                          <div className="approve_popup_header text_center relative pb_0  fpg_approve_popup">
                            <span className="close_popup fpg_close_popup" onClick={this.onCancleFilter}>
                              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.192 0.343994L5.949 4.58599L1.707 0.343994L0.292999 1.75799L4.535 5.99999L0.292999 10.242L1.707 11.656L5.949 7.41399L10.192 11.656L11.606 10.242L7.364 5.99999L11.606 1.75799L10.192 0.343994Z" fill="black" />
                              </svg>
                            </span>
                            
                            <div className="head_btn pointer upload_pdf_btn" onClick={() => this.downloadcsv()} style={{marginLeft:'17px',marginTop:'10px'}}>
                            <span  className="upload_pdf"></span>
                               Download Sample CSV</div>

                              <span className="head_btn pointer upload_pdf_btn"  style={{marginLeft:'17px',marginTop:'10px'}}><input type="file" accept=".csv" onChange={this.uploadCSV} className="upload_pdf" />Upload CSV <img src={UploadImg} style={{width:'19px',marginLeft:'5px',marginRight:'5px'}} />{this.state.fileUploading &&
                                    <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                }</span>
                          </div>
                        </div>
                      </div>
                    )}

                     {/* For CSV upload successfully */}
                     <div className={`user_popup ${this.state.successmodal ? "active" : null}`}>
                        <span className="popup_overlay" onClick={this.CloseModal}></span>
                        <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                            <div className="approve_popup_header text_center relative">
                                <p>You have successfully uploaded {this.state.totalAddedRecord} users</p>
                            </div>
                            <div className="content">
                                <div className="field_row text_center">
                                    <button className="small_btn active" onClick={this.CloseModal}>OK</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.state.uploadCSVModal ? <CsvUploadLocationModal CloseModal={this.CloseModal} totalAddedRecord={this.state.totalAddedRecord} totalSkippedRecord={this.state.totalSkippedRecord} skippedUser={this.state.skippedUser} /> : ''}


               {this.state.errorPopup ?
                    <ErrorPopUp
                        errorMsg={this.state.errorMsg}
                        errorMsgPopup={this.errorMsgPopup}
                    />
                    : ''
                }

                    {this.state.locationListArray && this.state.locationListArray.length ?
                        <div className="custom-pagination">
                            <ReactPaginate
                                previousLabel={""}
                                nextLabel={""}
                                breakLabel={"..."}
                                breakClassName={"break-me"}
                                pageCount={this.state.pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={this.handlePageClick}
                                containerClassName={"pagination"}
                                subContainerClassName={"pages pagination"}
                                activeClassName={"active"}
                                forcePage={this.state.currentPage}
                            />
                        </div>
                        : ''
                    }

                    {/* Loader */}
                    {this.state.loaderFlag ? (
                        <Loader />
                    ) : (
                            ""
                        )}
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationsList)